import { render } from "./HouseRest.vue?vue&type=template&id=e280f340&scoped=true"
import script from "./HouseRest.vue?vue&type=script&lang=js"
export * from "./HouseRest.vue?vue&type=script&lang=js"

import "./HouseRest.vue?vue&type=style&index=0&id=e280f340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e280f340"]])

export default __exports__